import React, { useState } from "react";
// import IconExportDownload from "@/components/icons/IconExportDownload";
// import IconExportArrow from "@/components/icons/IconExportArrow";
import PdfExport from "../../user-access/export-pdf";
import ExcelExport from "../../user-access/export-excel";
import { IconExportDownload } from "../../../assets/icons/icon-export-download";
import { IconExportArrow } from "../../../assets/icons/icon-export-arrow";

const ExportDropdown = ({ currentPageData, ListColumns }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const handleToggleDropdown = () => {
    setDropdownVisible((prevState) => !prevState);
  };
  return (
    <div className="relative">
      {/* Static Export Button */}
      <button className=" btn-primary black_color_btn focus:outline-none cursor-default h-[40px] ml-[10px]" onClick={handleToggleDropdown}>
        <IconExportDownload />
        <span className="pl-[10px]">Export</span>
        <span className="ml-2 text-xs text-gray-500">
          <IconExportArrow />
        </span>
      </button>

      {/* Always-visible dropdown */}
      {isDropdownVisible && (
        <div className="p-dd flex flex-col text-left border-solid border bg-white border-[#D1D7DC] w-full rounded-lg absolute -left-5 mt-5">
          <PdfExport
            name="PDF"
            icon={true}
            class="bg-red"
            tableData={currentPageData}
            columns={ListColumns}
            fileName="Account-list-export"
            classes="py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left"
          />
          <ExcelExport
            name="EXCEL"
            data={currentPageData}
            containerClass="py-[1px]"
            classes="py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left w-full"
          />
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
